import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { setReferralCode } from '../lib/referralStorage';
import { supabase } from '../lib/supabase';

/**
 * Custom hook to intercept 'ref', 'qr', 'crm_lead_id', or 'email' query parameters
 * from any entry route and persist them for onboarding extraction.
 */
export function useReferralTracker() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('ref') || searchParams.get('qr');
    if (code) {
      setReferralCode(code);
    }

    const crmLeadId = searchParams.get('crm_lead_id');
    if (crmLeadId) {
      try {
        localStorage.setItem('tc_crm_lead_id', crmLeadId.trim());
        // Track the click event asynchronously to update lead stage to 'ONBOARDING'
        const trackClick = async () => {
          try {
            const { error } = await supabase.rpc('track_crm_lead_click', { p_lead_id: crmLeadId.trim() });
            if (error) {
              console.warn('[CRM Lead Tracker] Error calling track_crm_lead_click:', error);
            }
          } catch (err) {
            console.error('[CRM Lead Tracker] Unhandled rejection calling track_crm_lead_click:', err);
          }
        };
        void trackClick();
      } catch (err) {
        console.warn('[CRM Lead Tracker] Failed to cache crm_lead_id:', err);
      }
    }

    const prefillEmail = searchParams.get('email');
    if (prefillEmail) {
      try {
        localStorage.setItem('tc_crm_prefill_email', prefillEmail.trim());
      } catch (err) {
        console.warn('[CRM Lead Tracker] Failed to cache pre-fill email:', err);
      }
    }
  }, [searchParams]);
}

